import { Fragment } from 'react'

import picOne from 'assets/img/research/what-students-developed/wsd-1.jpg'
import picTwo from 'assets/img/research/what-students-developed/wsd-2.jpg'
import picThree from 'assets/img/research/what-students-developed/wsd-3.jpg'
import picFour from 'assets/img/research/what-students-developed/wsd-4.jpg'
import picFive from 'assets/img/research/what-students-developed/wsd-5.jpg'
import picSix from 'assets/img/research/what-students-developed/wsd-6.jpg'
import picSeven from 'assets/img/research/what-students-developed/wsd-7.jpg'
import picEight from 'assets/img/research/what-students-developed/wsd-8.jpg'
import picNine from 'assets/img/research/what-students-developed/wsd-9.jpg'
import picTen from 'assets/img/research/what-students-developed/wsd-10.jpg'
import picEleven from 'assets/img/research/what-students-developed/wsd-11.jpg'
import picTwelve from 'assets/img/research/what-students-developed/wsd-12.jpg'
import picThirteen from 'assets/img/research/what-students-developed/wsd-13.jpg'

import usc from 'assets/img/research/symposium/usc.jpg'
import ucd from 'assets/img/research/symposium/ucd.jpg'
import uom from 'assets/img/research/symposium/uom.jpg'

export const whatStudentsDeveloped = {
  title: (
    <Fragment>
      What Students{' '}
      <span className="text-animated">
        <span>Develop</span>
      </span>
    </Fragment>
  ),
  // desc: 'To culminate the program, students will develop a scientific research poster, presentation deck and research paper to share their findings. They will learn how to professionally communicate their findings so they are confident and prepared for presentations at the TCS National Research Symposium.',
  desc: 'Students conduct research in industries that align with their interests, reinforcing their academic story to strengthen college applications and beyond. Culminating the program, students present their scientific research poster, presentation deck and research papers at the National Research Symposium. They will learn how to professionally communicate their findings so they are confident and prepared for presentations.',
  symposiums: {
    desc: 'Past Symposiums have been held at',
    locations: [
      { src: usc, alt: 'University of Southern California' },
      { src: ucd, alt: 'University of California' },
      { src: uom, alt: 'University of Maryland' },
    ],
  },
  projects: [
    picOne,
    picTwo,
    picThree,
    picFour,
    picFive,
    picSix,
    picSeven,
    picEight,
    picNine,
    picTen,
    picEleven,
    picTwelve,
    picThirteen,
  ],
}
